import { Button, Spin } from "antd";
import Modal from "antd/lib/modal/Modal";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { resetStatus, selectAuth } from "../../redux/reducers/slice/auth";
import { NAME_AUTH } from "../wishButton/authModal";

const ForgotPasswordModal = (props: any) => {
  const { type, setNameAuthModal } = props;
  const auth = useSelector(selectAuth);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleOk = async () => {
    props.setVisible(false);

    if (auth.status === 200) {
      if (type === "MODAL") {
        setNameAuthModal(NAME_AUTH.signIn);
      } else {
        props.history.goBack();
      }
    }
  };

  return (
    <Modal
      title={t("title_modal_notification")}
      visible={props.visible}
      onCancel={async () => {
        props.setVisible(false);
        await dispatch(await resetStatus());
      }}
      footer={[
        <Button type="primary" onClick={handleOk}>
          {auth.status === 200 ? t("btn_confirm") : t("btn_try_again")}
        </Button>,
      ]}>
      {auth.loading ? <Spin /> : <span>{auth.message}</span>}
    </Modal>
  );
};

export default ForgotPasswordModal;
